export const deals = [
  {
    id: 5,
    title: "Elden Ring: Shadow of the Erdtree",
    image: "/images/eldenring.jpg",
    oldPrice: 49.99,
    newPrice: 32.48,
    discount: 35,
    link: "https://amzn.to/47pd2Q3"
  },
  {
    id: 2,
    title: "Hogwarts Legacy : L'Héritage de Poudlard",
    image: "/images/hogwarts-legacy.jpg",
    oldPrice: 85.00,
    newPrice: 12.98,
    link: "https://www.instant-gaming.com/fr/13386-acheter-hogwarts-legacy-l-heritage-de-poudlard-deluxe-edition-deluxe-edition-xbox-series-x-s-xbox-one-jeu-microsoft-store/?igr=gamer-bc1658d"
  },
  {
    id: 3,
    title: "Assassin's Creed Shadows - Édition Limitée",
    image: "/images/acshadows.jpg",
    oldPrice: 70.00,
    newPrice: 28.99,
    link: "https://www.instant-gaming.com/fr/12831-acheter-assassin-s-creed-shadows-pc-ubisoft-connect/?igr=gamer-bc1658d"
  },
  {
    id: 4,
    title: "DualSense Edge Midnight Black (Version PRO)",
    image: "/images/dualsense_edge_black.jpg",
    newPrice: 199.00,
    link: "https://amzn.to/4rWM8Y9",
    isPremium: true
  }
];